var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "smenus" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c("Search", {
            attrs: {
              model: _vm.search,
              elem: _vm.searchElem,
              "btn-loading": _vm.list.loading,
              labelWidth: 80,
            },
            on: { "on-search": _vm.handleDataList },
          }),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "extra" }, slot: "extra" },
        [
          _c(
            "Button",
            { attrs: { icon: "md-add" }, on: { click: _vm.handleCreate } },
            [_vm._v("添加")]
          ),
        ],
        1
      ),
      _vm.toolbar.number
        ? _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("span", { staticClass: "number" }, [
                _vm._v(" Selected " + _vm._s(_vm.toolbar.number) + " items "),
              ]),
              _c(
                "Button",
                {
                  attrs: { type: "error", icon: "md-trash" },
                  on: { click: _vm.handleBatchRemove },
                },
                [_vm._v(" Remove ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("ITable", {
        ref: "list",
        attrs: {
          stripe: "",
          columns: _vm.columns,
          loading: _vm.list.loading,
          data: _vm.list.data,
          total: _vm.list.total,
        },
        on: {
          "on-page-change": _vm.handleDataList,
          "on-selection-change": _vm.handleSelectionChange,
        },
      }),
      _c("SmenuEdit", { ref: "edit", on: { "on-update": _vm.handleDataList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }